<template>
  <div class="geodkobjekter">
    <GeoDkObjektListItem
      :item="item"
      v-for="item in geoDkObjekterToShow"
      :key="item.get('geoDkId')"
      :removeItem="removeItem"
    />
  </div>
</template>

<script>
import GeoDkObjektListItem from './GeoDkObjektListItem.vue';
export default {
  name: 'geodk-objekt-list',
  components: {
    GeoDkObjektListItem,
  },
  props: {
    geoDkObjekterToShow: Array,
    removeItem: Function,
  },
};
</script>

<style lang="scss" scoped>
.border-bottom {
  width: 100%;
  border-radius: 2px;
  border-bottom: 2px solid $selected-color;
}

.arrow-down{
  width: 0;
  height: 0;
  left: 50%;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid $selected-color;
  margin: -1px auto;
  filter: drop-shadow(0.125rem 0.125rem 0.75rem rgba(0, 0, 0, 0.15));
}

svg {
  width: 220px;
  display: block;
}
</style>
